<template>
  <app-loading-section class="tab-loading-section" :loading="isLoading">
    <stats-team-chart :chart-data="comms"/>
  </app-loading-section>
</template>

<script>
import StatsTeamChart from "./StatsTeamChart.vue";
import api from "../../../api";
import utils from "../../../services/utils";

export default {
  name: "StatsTeamComms",
  components: {
    StatsTeamChart,
  },
  data() {
    return {
      isLoading: true,
      comms: [],
      chartTemplate: {
        label: '',
        total: 0,
        chart: {
          labels: [],
          datasets: [{
            label: '',
            ids: [],
            data: [],
            backgroundColor: [],
            hoverOffset: 4,
            borderWidth: 4,
          }]
        }
      },
    }
  },
  watch: {
    'activeTab' () {
      if (this.activeTab === 'StatsTeamComms') {
        this.loadStats()
      }
    }
  },
  computed: {
    activeTab() {
      return this.$store.getters['statsTeam/getActiveTab']
    },
    statFilter() {
      return this.$store.getters['statsTeam/getFilters']
    },
    chartBgColors() {
      return this.$store.getters['statsTeam/getChartBackgroundColors']
    },
  },
  methods: {
    loadStats() {
      this.isLoading = true
      this.comms = []

      const data = {
        start_at: this.statFilter.timeFrameValues.start,
        end_at: this.statFilter.timeFrameValues.end,
        users: this.statFilter.users
      }

      Promise.all([
        api.statsTeam.getCallsMade(data),
        api.statsTeam.getSmsSent(data),
        api.statsTeam.getEmailsSent(data),
        api.statsTeam.getInboundAddressed(data)
      ]).then(([
        resCallsMade,
        resSmsSent,
        resEmailsSent,
        resInboundAddressed
      ]) => {
        this.comms.push(
          this.formatResponse('Calls Made', resCallsMade.data),
          this.formatResponse('SMS Sent', resSmsSent.data),
          this.formatResponse('Emails Sent', resEmailsSent.data),
          this.formatResponse('Inbound Addressed', resInboundAddressed.data)
        )
      })
      .finally(() => this.isLoading = false)
    },
    formatResponse(label, response) {
      let chartData = utils.clone(this.chartTemplate)

      chartData.label = label
      if (response.length === 0) return chartData

      chartData.total = response.reduce((accumulator, res) => accumulator + res.total, 0)
      if (chartData.total) {
        chartData.chart.labels = response.map(res => res.user_name)
        chartData.chart.datasets[0].label = label

        response.forEach(res => {
          chartData.chart.datasets[0].ids.push(res.user_id)
          chartData.chart.datasets[0].data.push(res.total)

          const bgColor = this.chartBgColors.find(color => color.userId === res.user_id)
          if (bgColor) {
            chartData.chart.datasets[0].backgroundColor.push(bgColor.color)
          }
        })
      }

      return chartData
    }
  },
}
</script>

<style scoped lang="scss">

</style>
